import * as j from '@mojotech/json-type-validation';

export type ExternalTransferEntry = {
  name: string;
  phoneNumber: string;
  value: string;
};

export type ExternalTransferResponse = {
  nextPageUrl: string | null;
  transfers: ExternalTransferEntry[];
};

const ExternalTransferDecoder: j.Decoder<ExternalTransferEntry> = j
  .object({
    transfer_id: j.number(),
    name: j.string(),
    endpoint: j.string(),
    description: j.union(j.string(), j.constant(null)),
    type: j.string(),
  })
  .map((item: any) => ({
    name: item.name,
    phoneNumber: item.endpoint,
    value: item.endpoint,
  }));

export const ExternalTransfersResponseDecoder: j.Decoder<ExternalTransferResponse> = j
  .object({
    next_page_url: j.union(j.string(), j.constant(null)),
    transfers: j.array(ExternalTransferDecoder),
  })
  .map((item: any) => ({
    nextPageUrl: item.next_page_url,
    transfers: item.transfers,
  }));
